import styled from 'styled-components'
import { Form } from 'antd'
import { SPACING, TYPOGRAPHY, FONT_WEIGHT } from '../../../styles/theme'

export const FormContainer = styled.div`
  max-width: 100%;
`

export const StyledFormItem = styled(Form.Item)`
  margin-bottom: ${SPACING.lg};

  .ant-form-item-label > label {
    font-weight: ${FONT_WEIGHT.medium};
    color: var(--color-text-secondary);
    font-size: ${TYPOGRAPHY.caption.fontSize};
  }
`

export const FormActions = styled.div`
  display: flex;
  justify-content: flex-start;
  padding-top: ${SPACING.sm};
`
